/** Shown until the creator picks a name. Same fallback as `useAssistantName`. */
export const DEFAULT_ASSISTANT_NAME = 'Lighthouse'

/** First suggested name in the onboarding naming field (pre-filled, not a placeholder). */
export const SUGGESTED_ASSISTANT_NAME = 'Simone'

/** Shared pool for the assistant-name randomizer (onboarding, settings, prompt). */
export const ASSISTANT_NAMES = [
    'Alex', 'Simone', 'Ryan', 'Kevin', 'Jordan', 'Taylor', 'Morgan', 'Casey', 'Riley', 'Quinn', 'Avery',
    'Blake', 'Cameron', 'Dakota', 'Drew', 'Emery', 'Finley', 'Harper', 'Hayden', 'Max', 'Simon',
    'Jamie', 'Kai', 'Lane', 'Mackenzie', 'Noel', 'Parker', 'Peyton',
    'Reese', 'Rowan', 'Sawyer', 'Skyler', 'Spencer', 'Sydney', 'Tatum',
    'Ali', 'Ari', 'Charlie', 'Corey', 'Dallas', 'Devon', 'Eden',
    'Ellis', 'Frankie', 'Harley', 'Hollis', 'Jesse', 'Jules',
    'Lennox', 'Linden', 'Marlowe', 'Micah', 'Monroe',
    'Nico', 'Oakley', 'Palmer', 'Phoenix', 'Presley', 'Remy', 'River', 'Robin',
    'Rory', 'Sam', 'Shea', 'Sloane', 'Stevie', 'Sutton',
    'Toby', 'Val', 'Wren', 'Bellamy', 'Briar', 'Cedar', 'Darcy',
    'Jude', 'Kieran', 'Piper', 'Sol',
] as const

/** Title-case an assistant name so 'DREW' / 'drew' become 'Drew'. */
export function normalizeAssistantName(name: string): string {
    return name.trim().replace(/[^\p{L}]+|\p{L}+/gu, (part) => {
        if (!/^\p{L}/u.test(part)) return part
        return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()
    })
}

export function randomAssistantName(exclude?: string): string {
    let name = exclude || ''
    while (name === (exclude || '')) {
        name = ASSISTANT_NAMES[Math.floor(Math.random() * ASSISTANT_NAMES.length)]
    }
    return name
}
